import { render, staticRenderFns } from "./DialogSurvey.vue?vue&type=template&id=230affb3&scoped=true"
import script from "./DialogSurvey.vue?vue&type=script&lang=js"
export * from "./DialogSurvey.vue?vue&type=script&lang=js"
import style0 from "./DialogSurvey.vue?vue&type=style&index=0&id=230affb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230affb3",
  null
  
)

export default component.exports